import { type FC } from "react";
import { MenuItem, TextField } from "@mui/material";
import { PaymentCurrencyType } from "@/types/graphql/partner.generated";

interface CurrencyFieldProps {
  label: string;
  value: string;
  fullWidth?: boolean;
  onChange: (currency: string) => void;
}

// Единственный текущий выбор валюты (в фильтре Sales — не мультиселект),
// значения это PaymentCurrencyType (EUR/USD/MDL, AnalyticsSalesFilterInput.
// currency: PaymentCurrency), а не ProductCurrencyType (валюта цены продукта,
// см. features/products/ui/CurrencyField.tsx): набор значений тот же, но
// это разные enum'ы схемы.
export const CurrencyField: FC<CurrencyFieldProps> = ({
  label,
  value,
  onChange,
}) => (
  <TextField
    select
    fullWidth
    label={label}
    value={value}
    onChange={(event) => onChange(event.target.value)}
  >
    <MenuItem value="">—</MenuItem>
    <MenuItem value={PaymentCurrencyType.EurType}>EUR</MenuItem>
    <MenuItem value={PaymentCurrencyType.UsdType}>USD</MenuItem>
    <MenuItem value={PaymentCurrencyType.MdlType}>MDL</MenuItem>
    <MenuItem value={PaymentCurrencyType.GbpType}>GBP</MenuItem>
    <MenuItem value={PaymentCurrencyType.CadType}>CAD</MenuItem>
    <MenuItem value={PaymentCurrencyType.PlnType}>PLN</MenuItem>
  </TextField>
);
